import { messagingHubRoute } from './routes';

export const generateMessagingPath = (sequenceType: string, id: string, type: string) => {
  return `${messagingHubRoute}/${sequenceType}-${type.toLowerCase()}/${id}/edit`;
};
